<div class="container" fxLayout="column" fxLayoutGap="24px" *ngIf="publication">
  <section class="width-100" fxLayout="column" fxLayoutGap="24px" #shareContainer>
    <div class="title"> {{ publication.title }} </div>
    <div class="description"> {{ publication.desc }} </div>

    <section class="license-section" *ngIf="publication.license">
      <span class="tooltip">
        <!-- <uni-image [src]="publication.license.icon" alt="license" classes="width-100 height-100 cursor-pointer"></uni-image> -->
        <div class="wrapper" fxLayout="row">
          <i class="icon-copyright icon"></i>
          <h3 class="text margin-2 font-regular">
            {{ publication.license.code ? publication.license.code : publication.license.name }} </h3>
        </div>
        <div class="info">
          <p class="sparro-grey-800" style="margin: 0; font-weight: 600;">COPYRIGHT INFO</p>
          <p class="sparro-grey-800" style="margin-top: 10px;">{{ publication.license.info }}</p>
          <a *ngIf="publication.license.link" [href]="publication.license.link" target="_blank" class="sparro-blue-700">READ MORE</a>
        </div>
      </span>
    </section>

    <div class="tags-section" *ngIf="publication.tags.length > 0" fxLayout="row" fxLayoutGap="12px">
      <mat-chip-list>
        <mat-chip *ngFor="let tag of publication.tags" class="sparro-grey-900" [selectable]="false" [removable]="false">
          <ng-container *ngIf="tag.image; else defaultTagIcon">
            <uni-image
              [src]="tag.image"
              [alt]="tag.name"
              [height]="16"
              [width]="16"
              classes="fit-cover align-middle circle margin-right-2 sparro-bg-white">
            </uni-image>
          </ng-container>
          <ng-template #defaultTagIcon>
            <i class="icon-tag">
            </i>
          </ng-template>
          <a [href]="goToTopic(tag.slug)" class="no-decor" *ngIf="tag.slug"> {{ tag.name }} </a>
          <span *ngIf="!tag.slug"> {{ tag.name }} </span>
        </mat-chip>
      </mat-chip-list>
    </div>
    <div fxLayout="row">
      <span style="font-size: 16px; margin-bottom: 8px;"> Added <strong>{{ publication.publication_type.name }}</strong> on
        <span style="font-weight: 500;">
          {{ publication.updated_at | date : "d MMM, yyyy" }}
        </span>
        <span *ngIf="publication?.disciplines?.length > 0">under
          <span *ngFor="let discipline of publication.disciplines; index as i; let last=last" style="font-weight: 500;">
            <a [href]="goToTopic(discipline.slug)" class="no-decor" *ngIf="discipline.slug">{{ discipline.name }}<span *ngIf="!last">, </span></a>
            <div *ngIf="!discipline.slug">{{ discipline.name }}<span *ngIf="!last">, </span></div>
          </span>
        </span>
      </span>
    </div>
  </section>

  <div fxLayout="column" fxLayoutGap="24px" *ngIf="showUser">
    <mat-divider style="border-top-width:2.5px"></mat-divider>

    <section fxLayout="row" fxLayoutAlign="space-between center">
      <div fxLayout="row" fxLayoutGap="24px" fxLayoutAlign="center center">
        <uni-user-avatar
          [user]="publication.author"
          avatarClass="author-avatar">
        </uni-user-avatar>

        <div fxLayout="column" fxLayoutGap="8px" style="flex-grow: 1;">
          <a [href]="getProfileUrl(publication.author)" class="no-decor" target="_blank">
            <span class="username-text">{{ publication.author?.first_name | titlecase }} {{ publication.author?.last_name | titlecase }}</span>
          </a>
          <span class="bio-text">{{ publication.author?.bio | truncate : 100 }}</span>
        </div>
      </div>

      <!-- active="Following"
      activeHover="Unfollow"
      inactiveHover="Follow"
      [activeState]="true" -->
      <uni-state-button *ngIf="publication.author && !self"
        [default]="publication?.author?.is_following ? 'Following' : 'Follow'"
        (click)="toggleUserFollow()"
        button_class="secondary">
      </uni-state-button>

    </section>
    <mat-divider style="border-top-width:2.5px"></mat-divider>
  </div>
</div>
